import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocOnCallRoute: InvariantJiraRoute = {
	name: 'eoc-on-call',
	path: '/jira/ops/teams/:teamId/on-call',
	exact: true,
};
